'use strict';

/**
 * Utilitários e funções auxiliares
 * Contém máscaras para formatação, validações e manipulação de strings
 * Versão modernizada com menor dependência de jQuery
 */
const $FUNC = {};

/**
 * Funções de máscara para formatação de dados
 */
$FUNC.mask = {
    /**
     * Formata um número de telefone
     * @param {string} v - Valor a ser formatado
     * @returns {string} Telefone formatado (XX) XXXXX-XXXX
     */
    telefone: (v) => {
        return v ? v.replace(/\D/g, '').replace(/^(\d{2})(\d)/g, "($1)\ $2").replace(/(\d)(\d{4})$/, "$1-$2") : null;
    },
    
    /**
     * Formata um número de CPF
     * @param {string} v - Valor a ser formatado
     * @returns {string} CPF formatado XXX.XXX.XXX-XX
     */
    cpf: (v) => {
        return v ? v.replace(/\D/g, '').replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4") : null;
    }
};

/**
 * Valida um endereço de e-mail
 * @param {string} email - Email a ser validado
 * @returns {boolean} Verdadeiro se o email for válido
 */
$FUNC.email = (email) => {
    const user = email.substring(0, email.indexOf("@"));
    const domain = email.substring(email.indexOf("@") + 1, email.length);
    
    return (
        (user.length >= 1) &&
        (domain.length >= 3) &&
        (user.search("@") === -1) &&
        (domain.search("@") === -1) &&
        (user.search(" ") === -1) &&
        (domain.search(" ") === -1) &&
        (domain.search(".") !== -1) &&
        (domain.indexOf(".") >= 1) &&
        (domain.lastIndexOf(".") < domain.length - 1)
    );
};

/**
 * Comportamento de máscara para telefones brasileiros
 * Identifica automaticamente se é celular (9 dígitos) ou fixo (8 dígitos)
 */
$FUNC.SPMaskBehavior = function(val) {
    // Primeiro removemos todos os caracteres não numéricos para contar corretamente
    const numDigits = val.replace(/\D/g, '').length;
    // Se for 11 dígitos (celular com DDD), usamos a máscara com 5 dígitos no meio
    return numDigits === 11 ? "(00) 00000-0000" : "(00) 0000-0000";
};

/**
 * Opções para máscaras de telefone
 */
const spOptions = {
    onKeyPress: function(val, e, field, options) {
        // Utilizamos o objeto mask armazenado no elemento para aplicar a máscara
        const maskData = field.data('mask');
        if (maskData && typeof maskData.getMaskedVal === 'function') {
            // Temos que remover caracteres não numéricos para detectar o formato correto
            const rawValue = val.replace(/\D/g, '');
            // Obtemos o padrão de máscara correto baseado no número de dígitos
            const pattern = $FUNC.SPMaskBehavior(rawValue);
            // Armazenamos a nova máscara no objeto
            maskData.mask = pattern;
            // Aplicamos a máscara atualizada
            const maskedValue = maskData.getMaskedVal(val);
            field.val(maskedValue);
            return maskedValue;
        }
        return val;
    }
};

/**
 * Utilitários para manipulação de strings
 */
$FUNC.string = {
    /**
     * Limita o tamanho de um texto
     * @param {string} str - String a ser limitada
     * @param {number} limit - Tamanho máximo
     * @returns {string} Texto limitado
     */
    textolimite: (str, limit) => {
        if (str.length > limit) {
            str = str.substr(0, limit) + '.';
        }
        return str;
    },
    
    /**
     * Remove acentos e caracteres especiais
     * @param {string} str - String a ser convertida
     * @returns {string} String sem acentos e caracteres especiais
     */
    caminhoString: (str) => {
        str = str.replace(/[áàãâä]/g, 'a');
        str = str.replace(/[éèêë]/g, 'e');
        str = str.replace(/[íìîï]/g, 'i');
        str = str.replace(/[óòõôö]/g, 'o');
        str = str.replace(/[úùûü]/g, 'u');
        str = str.replace(/[ç]/g, 'c');
        str = str.replace(/[^a-zA-Z0-9]/g, '');
        return str.toLowerCase();
    },
    
    /**
     * Abrevia um nome, mantendo o primeiro nome completo
     * @param {string} nome - Nome completo
     * @returns {string} Nome abreviado
     */
    abrevianome: (nome) => {
        const partesNome = nome.split(' ');
        let index = 0;
        let nomeAbreviado = '';
        
        if (partesNome.length > 0) {
            partesNome.forEach((parte, i) => {
                const parteUpper = parte.toUpperCase();
                
                if (index > 0 && !['DA', 'DE', 'DO', 'DAS', 'DOS'].includes(parteUpper)) {
                    nomeAbreviado += parteUpper.substring(0, 1) + '. ';
                }
                index++;
            });
        }
        
        return partesNome[0] + ' ' + nomeAbreviado.trim();
    },
    
    /**
     * Retorna o primeiro nome
     * @param {string} nome - Nome completo
     * @returns {string} Primeiro nome
     */
    primeironome: (nome) => {
        return $FUNC.string.abrevianome(nome).split(' ', 1)[0];
    },
    
    /**
     * Capitaliza a primeira letra de uma string
     * @param {string} string - String a ser capitalizada
     * @returns {string} String com a primeira letra maiúscula
     */
    capitalize: (string) => {
        return string ? string.charAt(0).toUpperCase() + string.slice(1).toLowerCase() : '';
    },
    
    /**
     * Converte todas as primeiras letras de cada palavra para maiúsculo
     * @param {string} text - Texto a ser formatado
     * @returns {string} Texto com as primeiras letras maiúsculas
     */
    titleize: (text) => {
        const words = text.toLowerCase().split(" ");
        
        return words.map(word => {
            return word ? word[0].toUpperCase() + word.slice(1) : '';
        }).join(" ");
    }
};